// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"Quote_blockquote__hze60","body":"Quote_body__HNcnR","footer":"Quote_footer__jVkQg","scribble":"Quote_scribble__hdSFH"};